import applyFeatureFlags from '@/lib/helpers/apply-feature-flags'

export default applyFeatureFlags
